import * as React from "react";
var context = React.createContext('white');
export var ThemeContextProvider = context.Provider;
export var ThemeContextConsumer = context.Consumer;
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/context/theme.js
// module id = 288
// module chunks = 0